module.exports = __webpack_public_path__ + "927b4ddc054c91cc7c723796d569c423.MP3";